import { NON_MECHANICAL_BASE } from './_shared'

/**
 * Perfil EVACUACIÓN ENTERRADA (buried_evacuation_line). No-mecánico.
 * Hoy usa los defaults no-mecánicos (screenshot 'preview.png', sin codePrefix) —
 * igual que el comportamiento actual (no tiene mapeo propio). TODO: si necesita
 * screenshot/prefix propios, sobre-escribir aquí como electrical/trenches.
 */
export default {
  ...NON_MECHANICAL_BASE,
}
